import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { FormContext } from '../context/FormContext';
import languages from '../languages';
import ACTIONS from './actions';
/**
 * @param {string} fieldId Unique field id
 * @returns {import('./types').EcrionFormData}
 */

var useFormDataLayer = function useFormDataLayer(fieldId) {
  /**
   * @type {[import('./types').EcrionFormState, any]}
   */
  var _React$useContext = React.useContext(FormContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var load = function load(form) {
    return dispatch({
      type: ACTIONS.FORM_LOADED,
      payload: form
    });
  };

  var setData = function setData(data) {
    return dispatch({
      type: ACTIONS.SET_DATA,
      payload: data
    });
  };

  if (!fieldId) return {
    state: state,
    actions: {
      load: load,
      setData: setData
    },
    dispatch: dispatch
  };
  if (fieldId === 'FOCUSED_FIELD') return state.meta['FOCUSED_FIELD'];
  if (fieldId === 'FORM_PAGES_FIELD') return {
    value: state.meta['FORM_PAGES_FIELD'],
    dispatch: dispatch
  };
  var field = state.fields[fieldId];
  var meta = state.meta[fieldId];
  var data = state.data[fieldId];
  var translatedProperties = languages.translate(state, field);
  return _objectSpread({
    value: data
  }, field, translatedProperties, meta, {
    dispatch: dispatch
  });
};

export default useFormDataLayer;